import { render, staticRenderFns } from "./tournamentStatistics.vue?vue&type=template&id=90995cda&scoped=true&"
import script from "./tournamentStatistics.vue?vue&type=script&lang=js&"
export * from "./tournamentStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90995cda",
  null
  
)

export default component.exports